import { LearningDashboardSkeleton } from './components/learning-dashboard-skeleton/learning-dashboard-skeleton';

export const LearningDashboardLoadingView = () => <LearningDashboardSkeleton />;
